import axios from 'axios';
import cachios from 'cachios';

// create a .config.js file at the app root and export your token
import { token } from '../../.config';

const axiosInstance = axios.create({
  baseURL: 'https://api.synopticlabs.org/v2',
  // timeout: 15000,
  params: {
    token,
    obtimezone: 'local',
    units: 'temp|F,speed|mph,height|ft,precip|in,height|ft,english',
  },
});

const cachiosOptions = {
  stdTTL: 5 * 60,  //  time to live in seconds
  checkperiod: 5 * 60,  //  time to live in seconds
  ttl: 5 * 60,  //  time to live in seconds,
};

const request = cachios.create(axiosInstance, cachiosOptions);

export default class {

  static get(url, options) {
    /* eslint-disable */
    if (options) {
      options.ttl = 5 * 60;
    } else {
      options = {
        ttl: 5 * 60,
      };
    }
    return request.get(url, options);
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js